import { Product, Order, CancelOrderPayload, InvestmentPlan, ApproveOrderPayload } from '../../../models/orders';
import { Action } from "@ngrx/store";
import { BuyPayload } from "src/app/models/orders";
import { HideLoader, ShowLoader } from 'src/app/shared/decorators/loader';
import { ClientEntity } from 'src/app/models/clients';

export const GET_PRODUCTS_LIST = '[trading] get product list';
export const GET_PRODUCTS_LIST_SUCCESS = '[trading] get product list success';

export const GET_CURRENT_ORDERS_LIST = '[trading] get current order list';
export const GET_CURRENT_ORDERS_LIST_SUCCESS = '[trading] get current order list success';
export const GET_CURRENT_ORDERS_LIST_FAIL = '[trading] get current order list fail';

export const CANCEL_PENDING_ORDER = '[trading] cancel pending order';

export const APPROVE_ORDER = '[trading] approve order';

export const UPDATE_STATUS = '[trading] Status Updated';

export const GET_REGULAR_INVESTMENT_PLAN = '[trading] Get investment plan';
export const SAVE_REGULAR_INVESTMENT_PLAN = '[trading] Save investment plan';
export const GET_REGULAR_INVESTMENT_PLAN_SUCCESS = '[trading] Get investment plan success';
export const GET_REGULAR_INVESTMENT_PLAN_NOT_FOUND = '[trading] Get investment plan not found';

export class GetAvailableProducts implements Action {
    readonly type = GET_PRODUCTS_LIST;
    readonly payload: number;
    constructor(portfolioId: number) {
        this.payload = portfolioId;
    }
}
export class GetAvailableProductsSuccess implements Action {
    readonly type = GET_PRODUCTS_LIST_SUCCESS;
    readonly payload: Product[];
    constructor(productsList: Product[]) {
        this.payload = productsList;
    }
}

@ShowLoader()
export class GetCurrentOrders implements Action {
    readonly type = GET_CURRENT_ORDERS_LIST;
    constructor(public payload: ClientEntity[]) { }
}

@HideLoader(GET_CURRENT_ORDERS_LIST)
export class GetCurrentOrdersSuccess implements Action {
    readonly type = GET_CURRENT_ORDERS_LIST_SUCCESS;
    readonly payload: Order[];
    constructor(ordersList: Order[]) {
        this.payload = ordersList;
    }
}

@HideLoader(GET_CURRENT_ORDERS_LIST)
export class GetCurrentOrdersFail implements Action {
    readonly type = GET_CURRENT_ORDERS_LIST_FAIL;
}


export class CancelPendingOrder implements Action {
    readonly type = CANCEL_PENDING_ORDER;
    constructor(public payload: CancelOrderPayload) {}
}

export class ApproveOrder implements Action {
    readonly type = APPROVE_ORDER;
    constructor(public payload: ApproveOrderPayload) { }
}

export class UpdateStatus implements Action {
  readonly type = UPDATE_STATUS;
  constructor() {}
}

export class GetRegularInvestmentPlan implements Action {
    readonly type = GET_REGULAR_INVESTMENT_PLAN;
    constructor(public payload: number) {}
}

export class GetRegularInvestmentPlanSuccess implements Action {
    readonly type = GET_REGULAR_INVESTMENT_PLAN_SUCCESS;
    constructor(public payload: InvestmentPlan) { }
}

export class GetRegularInvestmentPlanNotFound implements Action {
    readonly type = GET_REGULAR_INVESTMENT_PLAN_NOT_FOUND;
}

export class SaveRegularInvestmentPlan implements Action {
    readonly type = SAVE_REGULAR_INVESTMENT_PLAN;
    constructor(public payload: InvestmentPlan) { }
}

export type TradingActions =
  | GetAvailableProducts
  | GetAvailableProductsSuccess
  | GetCurrentOrders
  | GetCurrentOrdersSuccess
  | UpdateStatus
  | CancelPendingOrder
  | ApproveOrder
  | GetRegularInvestmentPlan
  | SaveRegularInvestmentPlan
  | GetRegularInvestmentPlanSuccess
  | GetRegularInvestmentPlanNotFound;
